/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * Leave Service API
 * Leave management microservice (multi-step approvals, delegation, holidays)
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import * as axios from "axios";
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";

import type {
  AllDelegationsParams,
  AllLeaveRequestsParams,
  ApiResponse,
  ApprovalActionDto,
  DashboardParams,
  DelegationAssignmentDto,
  DelegationRequestDto,
  DeleteHolidayParams,
  DeleteLeaveTypeParams,
  DepartmentPerformanceParams,
  DepartmentPerformanceReportResponse,
  DirectoratePerformanceParams,
  DirectoratePerformanceReportResponse,
  EligibleLeaveTypesForUserParams,
  EmployeeLeaveEntitlementReportRequest,
  EmployeeLeaveEntitlementReportResponse,
  HolidayDto,
  HolidayResponseDto,
  LeaveBalanceDto,
  LeaveDashboardReportResponse,
  LeaveRequestCreateDto,
  LeaveRequestDto,
  LeaveRequestUpdateDto,
  LeaveRequestsByScopeParams,
  LeaveSummaryReportResponse,
  LeaveTrackingDto,
  LeaveTypeConfigDto,
  LeaveTypeGroupUsageReportResponse,
  LeaveTypeGroupsParams,
  LeaveTypeUsageParams,
  LeaveTypeUsageReportResponse,
  ListAllLeaveTypesParams,
  ListHolidaysParams,
  MyBalancesParams,
  MyDelegationsParams,
  MyEligibleLeaveTypesParams,
  MyRequestsParams,
  OrganisationBalancesParams,
  PageDelegationAssignmentDto,
  PageHolidayResponseDto,
  PageLeaveRequestAdminListItemDto,
  PageLeaveRequestDto,
  PageLeaveTypeDto,
  SummaryParams,
  SupervisorApprovedRequestsParams,
  SupervisorPendingRequestsParams,
  TriggerYearEndRolloverParams,
  UserBalancesParams,
  UserLeaveTypeBalanceParams,
} from "./models";

/**
 * Update an existing holiday
 * @summary Update a holiday
 */
export const updateHoliday = (
  id: number,
  holidayDto: HolidayDto,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HolidayResponseDto>> => {
  return axios.default.put(
    `https://leave.uibfs.or.ug/uib-api/leave/config/holidays/${id}`,
    holidayDto,
    options,
  );
};

export const getUpdateHolidayMutationOptions = <
  TError = AxiosError<HolidayResponseDto | HolidayResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateHoliday>>,
    TError,
    { id: number; data: HolidayDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateHoliday>>,
  TError,
  { id: number; data: HolidayDto },
  TContext
> => {
  const mutationKey = ["updateHoliday"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateHoliday>>,
    { id: number; data: HolidayDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateHoliday(id, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateHolidayMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateHoliday>>
>;
export type UpdateHolidayMutationBody = HolidayDto;
export type UpdateHolidayMutationError = AxiosError<
  HolidayResponseDto | HolidayResponseDto
>;

/**
 * @summary Update a holiday
 */
export const useUpdateHoliday = <
  TError = AxiosError<HolidayResponseDto | HolidayResponseDto>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateHoliday>>,
      TError,
      { id: number; data: HolidayDto },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateHoliday>>,
  TError,
  { id: number; data: HolidayDto },
  TContext
> => {
  const mutationOptions = getUpdateHolidayMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Returns per-employee leave entitlement and usage for the selected quarter or full year.
 * @summary Employee leave entitlements vs usage
 */
export const employeeEntitlements = (
  employeeLeaveEntitlementReportRequest: EmployeeLeaveEntitlementReportRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<EmployeeLeaveEntitlementReportResponse>> => {
  return axios.default.post(
    `https://leave.uibfs.or.ug/uib-api/leave/reports/employee-entitlements`,
    employeeLeaveEntitlementReportRequest,
    options,
  );
};

export const getEmployeeEntitlementsMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof employeeEntitlements>>,
    TError,
    { data: EmployeeLeaveEntitlementReportRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof employeeEntitlements>>,
  TError,
  { data: EmployeeLeaveEntitlementReportRequest },
  TContext
> => {
  const mutationKey = ["employeeEntitlements"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof employeeEntitlements>>,
    { data: EmployeeLeaveEntitlementReportRequest }
  > = (props) => {
    const { data } = props ?? {};

    return employeeEntitlements(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type EmployeeEntitlementsMutationResult = NonNullable<
  Awaited<ReturnType<typeof employeeEntitlements>>
>;
export type EmployeeEntitlementsMutationBody =
  EmployeeLeaveEntitlementReportRequest;
export type EmployeeEntitlementsMutationError = AxiosError<unknown>;

/**
 * @summary Employee leave entitlements vs usage
 */
export const useEmployeeEntitlements = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof employeeEntitlements>>,
      TError,
      { data: EmployeeLeaveEntitlementReportRequest },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof employeeEntitlements>>,
  TError,
  { data: EmployeeLeaveEntitlementReportRequest },
  TContext
> => {
  const mutationOptions = getEmployeeEntitlementsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Runs the pending-approval reminder job immediately for eligible leave requests.
 * @summary Trigger pending-approval reminders (Admin)
 */
export const triggerPendingApprovalReminders = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ApiResponse>> => {
  return axios.default.post(
    `https://leave.uibfs.or.ug/uib-api/leave/reminders/pending-approvals/trigger`,
    undefined,
    options,
  );
};

export const getTriggerPendingApprovalRemindersMutationOptions = <
  TError = AxiosError<ApiResponse | ApiResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof triggerPendingApprovalReminders>>,
    TError,
    void,
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof triggerPendingApprovalReminders>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["triggerPendingApprovalReminders"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof triggerPendingApprovalReminders>>,
    void
  > = () => {
    return triggerPendingApprovalReminders(axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TriggerPendingApprovalRemindersMutationResult = NonNullable<
  Awaited<ReturnType<typeof triggerPendingApprovalReminders>>
>;

export type TriggerPendingApprovalRemindersMutationError = AxiosError<
  ApiResponse | ApiResponse
>;

/**
 * @summary Trigger pending-approval reminders (Admin)
 */
export const useTriggerPendingApprovalReminders = <
  TError = AxiosError<ApiResponse | ApiResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof triggerPendingApprovalReminders>>,
      TError,
      void,
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof triggerPendingApprovalReminders>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions =
    getTriggerPendingApprovalRemindersMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Retrieve paginated list of current user's leave requests
 * @summary Get my leave requests
 */
export const myRequests = (
  params: MyRequestsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<PageLeaveRequestDto>> => {
  return axios.default.get(
    `https://leave.uibfs.or.ug/uib-api/leave/leave-requests`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getMyRequestsQueryKey = (params?: MyRequestsParams) => {
  return [
    `https://leave.uibfs.or.ug/uib-api/leave/leave-requests`,
    ...(params ? [params] : []),
  ] as const;
};

export const getMyRequestsQueryOptions = <
  TData = Awaited<ReturnType<typeof myRequests>>,
  TError = AxiosError<PageLeaveRequestDto>,
>(
  params: MyRequestsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof myRequests>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getMyRequestsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof myRequests>>> = ({
    signal,
  }) => myRequests(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof myRequests>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type MyRequestsQueryResult = NonNullable<
  Awaited<ReturnType<typeof myRequests>>
>;
export type MyRequestsQueryError = AxiosError<PageLeaveRequestDto>;

export function useMyRequests<
  TData = Awaited<ReturnType<typeof myRequests>>,
  TError = AxiosError<PageLeaveRequestDto>,
>(
  params: MyRequestsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof myRequests>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof myRequests>>,
          TError,
          Awaited<ReturnType<typeof myRequests>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useMyRequests<
  TData = Awaited<ReturnType<typeof myRequests>>,
  TError = AxiosError<PageLeaveRequestDto>,
>(
  params: MyRequestsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof myRequests>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof myRequests>>,
          TError,
          Awaited<ReturnType<typeof myRequests>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useMyRequests<
  TData = Awaited<ReturnType<typeof myRequests>>,
  TError = AxiosError<PageLeaveRequestDto>,
>(
  params: MyRequestsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof myRequests>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get my leave requests
 */

export function useMyRequests<
  TData = Awaited<ReturnType<typeof myRequests>>,
  TError = AxiosError<PageLeaveRequestDto>,
>(
  params: MyRequestsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof myRequests>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getMyRequestsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Employee submits a new leave application
 * @summary Submit a new leave request
 */
export const submitLeave = (
  leaveRequestCreateDto: LeaveRequestCreateDto,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ApiResponse>> => {
  return axios.default.post(
    `https://leave.uibfs.or.ug/uib-api/leave/leave-requests`,
    leaveRequestCreateDto,
    options,
  );
};

export const getSubmitLeaveMutationOptions = <
  TError = AxiosError<ApiResponse | ApiResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitLeave>>,
    TError,
    { data: LeaveRequestCreateDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof submitLeave>>,
  TError,
  { data: LeaveRequestCreateDto },
  TContext
> => {
  const mutationKey = ["submitLeave"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof submitLeave>>,
    { data: LeaveRequestCreateDto }
  > = (props) => {
    const { data } = props ?? {};

    return submitLeave(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SubmitLeaveMutationResult = NonNullable<
  Awaited<ReturnType<typeof submitLeave>>
>;
export type SubmitLeaveMutationBody = LeaveRequestCreateDto;
export type SubmitLeaveMutationError = AxiosError<ApiResponse | ApiResponse>;

/**
 * @summary Submit a new leave request
 */
export const useSubmitLeave = <
  TError = AxiosError<ApiResponse | ApiResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof submitLeave>>,
      TError,
      { data: LeaveRequestCreateDto },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof submitLeave>>,
  TError,
  { data: LeaveRequestCreateDto },
  TContext
> => {
  const mutationOptions = getSubmitLeaveMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Applicant cancels a leave request. If already approved, unused days are refunded.
 * @summary Revert a leave request
 */
export const revertLeave = (
  id: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ApiResponse>> => {
  return axios.default.post(
    `https://leave.uibfs.or.ug/uib-api/leave/leave-requests/${id}/revert`,
    undefined,
    options,
  );
};

export const getRevertLeaveMutationOptions = <
  TError = AxiosError<ApiResponse | ApiResponse | ApiResponse | ApiResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof revertLeave>>,
    TError,
    { id: number },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof revertLeave>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["revertLeave"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof revertLeave>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return revertLeave(id, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RevertLeaveMutationResult = NonNullable<
  Awaited<ReturnType<typeof revertLeave>>
>;

export type RevertLeaveMutationError = AxiosError<
  ApiResponse | ApiResponse | ApiResponse | ApiResponse
>;

/**
 * @summary Revert a leave request
 */
export const useRevertLeave = <
  TError = AxiosError<ApiResponse | ApiResponse | ApiResponse | ApiResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof revertLeave>>,
      TError,
      { id: number },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof revertLeave>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getRevertLeaveMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Supervisor processes the current approval step for a leave request
 * @summary Approve or reject a leave request
 */
export const approveOrReject = (
  id: number,
  approvalActionDto: ApprovalActionDto,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<LeaveRequestDto>> => {
  return axios.default.post(
    `https://leave.uibfs.or.ug/uib-api/leave/leave-requests/${id}/clearance`,
    approvalActionDto,
    options,
  );
};

export const getApproveOrRejectMutationOptions = <
  TError = AxiosError<
    LeaveRequestDto | LeaveRequestDto | LeaveRequestDto | LeaveRequestDto
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof approveOrReject>>,
    TError,
    { id: number; data: ApprovalActionDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof approveOrReject>>,
  TError,
  { id: number; data: ApprovalActionDto },
  TContext
> => {
  const mutationKey = ["approveOrReject"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof approveOrReject>>,
    { id: number; data: ApprovalActionDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return approveOrReject(id, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApproveOrRejectMutationResult = NonNullable<
  Awaited<ReturnType<typeof approveOrReject>>
>;
export type ApproveOrRejectMutationBody = ApprovalActionDto;
export type ApproveOrRejectMutationError = AxiosError<
  LeaveRequestDto | LeaveRequestDto | LeaveRequestDto | LeaveRequestDto
>;

/**
 * @summary Approve or reject a leave request
 */
export const useApproveOrReject = <
  TError = AxiosError<
    LeaveRequestDto | LeaveRequestDto | LeaveRequestDto | LeaveRequestDto
  >,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof approveOrReject>>,
      TError,
      { id: number; data: ApprovalActionDto },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof approveOrReject>>,
  TError,
  { id: number; data: ApprovalActionDto },
  TContext
> => {
  const mutationOptions = getApproveOrRejectMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Admin submits a leave request for a user and skips notice period validation
 * @summary Submit a leave request as admin
 */
export const submitLeaveAsAdmin = (
  userId: number,
  leaveRequestCreateDto: LeaveRequestCreateDto,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ApiResponse>> => {
  return axios.default.post(
    `https://leave.uibfs.or.ug/uib-api/leave/leave-requests/admin/${userId}`,
    leaveRequestCreateDto,
    options,
  );
};

export const getSubmitLeaveAsAdminMutationOptions = <
  TError = AxiosError<ApiResponse | ApiResponse | ApiResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitLeaveAsAdmin>>,
    TError,
    { userId: number; data: LeaveRequestCreateDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof submitLeaveAsAdmin>>,
  TError,
  { userId: number; data: LeaveRequestCreateDto },
  TContext
> => {
  const mutationKey = ["submitLeaveAsAdmin"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof submitLeaveAsAdmin>>,
    { userId: number; data: LeaveRequestCreateDto }
  > = (props) => {
    const { userId, data } = props ?? {};

    return submitLeaveAsAdmin(userId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SubmitLeaveAsAdminMutationResult = NonNullable<
  Awaited<ReturnType<typeof submitLeaveAsAdmin>>
>;
export type SubmitLeaveAsAdminMutationBody = LeaveRequestCreateDto;
export type SubmitLeaveAsAdminMutationError = AxiosError<
  ApiResponse | ApiResponse | ApiResponse
>;

/**
 * @summary Submit a leave request as admin
 */
export const useSubmitLeaveAsAdmin = <
  TError = AxiosError<ApiResponse | ApiResponse | ApiResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof submitLeaveAsAdmin>>,
      TError,
      { userId: number; data: LeaveRequestCreateDto },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof submitLeaveAsAdmin>>,
  TError,
  { userId: number; data: LeaveRequestCreateDto },
  TContext
> => {
  const mutationOptions = getSubmitLeaveAsAdminMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Retrieve paginated list of active delegation assignments
 * @summary Get my delegations
 */
export const myDelegations = (
  params: MyDelegationsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<PageDelegationAssignmentDto>> => {
  return axios.default.get(
    `https://leave.uibfs.or.ug/uib-api/leave/delegations`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getMyDelegationsQueryKey = (params?: MyDelegationsParams) => {
  return [
    `https://leave.uibfs.or.ug/uib-api/leave/delegations`,
    ...(params ? [params] : []),
  ] as const;
};

export const getMyDelegationsQueryOptions = <
  TData = Awaited<ReturnType<typeof myDelegations>>,
  TError = AxiosError<PageDelegationAssignmentDto>,
>(
  params: MyDelegationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof myDelegations>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getMyDelegationsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof myDelegations>>> = ({
    signal,
  }) => myDelegations(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof myDelegations>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type MyDelegationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof myDelegations>>
>;
export type MyDelegationsQueryError = AxiosError<PageDelegationAssignmentDto>;

export function useMyDelegations<
  TData = Awaited<ReturnType<typeof myDelegations>>,
  TError = AxiosError<PageDelegationAssignmentDto>,
>(
  params: MyDelegationsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof myDelegations>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof myDelegations>>,
          TError,
          Awaited<ReturnType<typeof myDelegations>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useMyDelegations<
  TData = Awaited<ReturnType<typeof myDelegations>>,
  TError = AxiosError<PageDelegationAssignmentDto>,
>(
  params: MyDelegationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof myDelegations>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof myDelegations>>,
          TError,
          Awaited<ReturnType<typeof myDelegations>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useMyDelegations<
  TData = Awaited<ReturnType<typeof myDelegations>>,
  TError = AxiosError<PageDelegationAssignmentDto>,
>(
  params: MyDelegationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof myDelegations>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get my delegations
 */

export function useMyDelegations<
  TData = Awaited<ReturnType<typeof myDelegations>>,
  TError = AxiosError<PageDelegationAssignmentDto>,
>(
  params: MyDelegationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof myDelegations>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getMyDelegationsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * User delegates their approval authority to another user with optional backup
 * @summary Create a delegation
 */
export const createDelegation = (
  delegationRequestDto: DelegationRequestDto,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<DelegationAssignmentDto>> => {
  return axios.default.post(
    `https://leave.uibfs.or.ug/uib-api/leave/delegations`,
    delegationRequestDto,
    options,
  );
};

export const getCreateDelegationMutationOptions = <
  TError = AxiosError<DelegationAssignmentDto | DelegationAssignmentDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createDelegation>>,
    TError,
    { data: DelegationRequestDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createDelegation>>,
  TError,
  { data: DelegationRequestDto },
  TContext
> => {
  const mutationKey = ["createDelegation"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createDelegation>>,
    { data: DelegationRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return createDelegation(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateDelegationMutationResult = NonNullable<
  Awaited<ReturnType<typeof createDelegation>>
>;
export type CreateDelegationMutationBody = DelegationRequestDto;
export type CreateDelegationMutationError = AxiosError<
  DelegationAssignmentDto | DelegationAssignmentDto
>;

/**
 * @summary Create a delegation
 */
export const useCreateDelegation = <
  TError = AxiosError<DelegationAssignmentDto | DelegationAssignmentDto>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createDelegation>>,
      TError,
      { data: DelegationRequestDto },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createDelegation>>,
  TError,
  { data: DelegationRequestDto },
  TContext
> => {
  const mutationOptions = getCreateDelegationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Retrieve leave types matching the current user's entitlements
 * @summary List leave types
 */
export const listAllLeaveTypes = (
  params: ListAllLeaveTypesParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<PageLeaveTypeDto>> => {
  return axios.default.get(
    `https://leave.uibfs.or.ug/uib-api/leave/config/leave-types`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getListAllLeaveTypesQueryKey = (
  params?: ListAllLeaveTypesParams,
) => {
  return [
    `https://leave.uibfs.or.ug/uib-api/leave/config/leave-types`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListAllLeaveTypesQueryOptions = <
  TData = Awaited<ReturnType<typeof listAllLeaveTypes>>,
  TError = AxiosError<unknown>,
>(
  params: ListAllLeaveTypesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listAllLeaveTypes>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListAllLeaveTypesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listAllLeaveTypes>>
  > = ({ signal }) => listAllLeaveTypes(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAllLeaveTypes>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListAllLeaveTypesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAllLeaveTypes>>
>;
export type ListAllLeaveTypesQueryError = AxiosError<unknown>;

export function useListAllLeaveTypes<
  TData = Awaited<ReturnType<typeof listAllLeaveTypes>>,
  TError = AxiosError<unknown>,
>(
  params: ListAllLeaveTypesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listAllLeaveTypes>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAllLeaveTypes>>,
          TError,
          Awaited<ReturnType<typeof listAllLeaveTypes>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListAllLeaveTypes<
  TData = Awaited<ReturnType<typeof listAllLeaveTypes>>,
  TError = AxiosError<unknown>,
>(
  params: ListAllLeaveTypesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listAllLeaveTypes>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAllLeaveTypes>>,
          TError,
          Awaited<ReturnType<typeof listAllLeaveTypes>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListAllLeaveTypes<
  TData = Awaited<ReturnType<typeof listAllLeaveTypes>>,
  TError = AxiosError<unknown>,
>(
  params: ListAllLeaveTypesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listAllLeaveTypes>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List leave types
 */

export function useListAllLeaveTypes<
  TData = Awaited<ReturnType<typeof listAllLeaveTypes>>,
  TError = AxiosError<unknown>,
>(
  params: ListAllLeaveTypesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listAllLeaveTypes>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getListAllLeaveTypesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a new leave type with entitlement rules and optional carryover/borrowing policy. Carryover fields (maxCarryoverDays, carryoverExpiryMonth, etc.) are saved inline — no separate endpoint needed.
 * @summary Create or update leave type
 */
export const upsertLeaveType = (
  leaveTypeConfigDto: LeaveTypeConfigDto,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ApiResponse>> => {
  return axios.default.post(
    `https://leave.uibfs.or.ug/uib-api/leave/config/leave-types`,
    leaveTypeConfigDto,
    options,
  );
};

export const getUpsertLeaveTypeMutationOptions = <
  TError = AxiosError<ApiResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof upsertLeaveType>>,
    TError,
    { data: LeaveTypeConfigDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof upsertLeaveType>>,
  TError,
  { data: LeaveTypeConfigDto },
  TContext
> => {
  const mutationKey = ["upsertLeaveType"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof upsertLeaveType>>,
    { data: LeaveTypeConfigDto }
  > = (props) => {
    const { data } = props ?? {};

    return upsertLeaveType(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpsertLeaveTypeMutationResult = NonNullable<
  Awaited<ReturnType<typeof upsertLeaveType>>
>;
export type UpsertLeaveTypeMutationBody = LeaveTypeConfigDto;
export type UpsertLeaveTypeMutationError = AxiosError<ApiResponse>;

/**
 * @summary Create or update leave type
 */
export const useUpsertLeaveType = <
  TError = AxiosError<ApiResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof upsertLeaveType>>,
      TError,
      { data: LeaveTypeConfigDto },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof upsertLeaveType>>,
  TError,
  { data: LeaveTypeConfigDto },
  TContext
> => {
  const mutationOptions = getUpsertLeaveTypeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Delete a leave type and its entitlement rules
 * @summary Delete a leave type
 */
export const deleteLeaveType = (
  params: DeleteLeaveTypeParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ApiResponse>> => {
  return axios.default.delete(
    `https://leave.uibfs.or.ug/uib-api/leave/config/leave-types`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getDeleteLeaveTypeMutationOptions = <
  TError = AxiosError<ApiResponse | ApiResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteLeaveType>>,
    TError,
    { params: DeleteLeaveTypeParams },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteLeaveType>>,
  TError,
  { params: DeleteLeaveTypeParams },
  TContext
> => {
  const mutationKey = ["deleteLeaveType"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteLeaveType>>,
    { params: DeleteLeaveTypeParams }
  > = (props) => {
    const { params } = props ?? {};

    return deleteLeaveType(params, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteLeaveTypeMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteLeaveType>>
>;

export type DeleteLeaveTypeMutationError = AxiosError<
  ApiResponse | ApiResponse
>;

/**
 * @summary Delete a leave type
 */
export const useDeleteLeaveType = <
  TError = AxiosError<ApiResponse | ApiResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteLeaveType>>,
      TError,
      { params: DeleteLeaveTypeParams },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteLeaveType>>,
  TError,
  { params: DeleteLeaveTypeParams },
  TContext
> => {
  const mutationOptions = getDeleteLeaveTypeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Retrieve paginated list of holidays, optionally filtered by date range
 * @summary List holidays
 */
export const listHolidays = (
  params: ListHolidaysParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<PageHolidayResponseDto>> => {
  return axios.default.get(
    `https://leave.uibfs.or.ug/uib-api/leave/config/holidays`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getListHolidaysQueryKey = (params?: ListHolidaysParams) => {
  return [
    `https://leave.uibfs.or.ug/uib-api/leave/config/holidays`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListHolidaysQueryOptions = <
  TData = Awaited<ReturnType<typeof listHolidays>>,
  TError = AxiosError<unknown>,
>(
  params: ListHolidaysParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listHolidays>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListHolidaysQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listHolidays>>> = ({
    signal,
  }) => listHolidays(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listHolidays>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListHolidaysQueryResult = NonNullable<
  Awaited<ReturnType<typeof listHolidays>>
>;
export type ListHolidaysQueryError = AxiosError<unknown>;

export function useListHolidays<
  TData = Awaited<ReturnType<typeof listHolidays>>,
  TError = AxiosError<unknown>,
>(
  params: ListHolidaysParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listHolidays>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listHolidays>>,
          TError,
          Awaited<ReturnType<typeof listHolidays>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListHolidays<
  TData = Awaited<ReturnType<typeof listHolidays>>,
  TError = AxiosError<unknown>,
>(
  params: ListHolidaysParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listHolidays>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listHolidays>>,
          TError,
          Awaited<ReturnType<typeof listHolidays>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListHolidays<
  TData = Awaited<ReturnType<typeof listHolidays>>,
  TError = AxiosError<unknown>,
>(
  params: ListHolidaysParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listHolidays>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List holidays
 */

export function useListHolidays<
  TData = Awaited<ReturnType<typeof listHolidays>>,
  TError = AxiosError<unknown>,
>(
  params: ListHolidaysParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listHolidays>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getListHolidaysQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Add a new holiday to the calendar
 * @summary Create a holiday
 */
export const saveHoliday = (
  holidayDto: HolidayDto,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HolidayResponseDto>> => {
  return axios.default.post(
    `https://leave.uibfs.or.ug/uib-api/leave/config/holidays`,
    holidayDto,
    options,
  );
};

export const getSaveHolidayMutationOptions = <
  TError = AxiosError<HolidayResponseDto>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveHoliday>>,
    TError,
    { data: HolidayDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof saveHoliday>>,
  TError,
  { data: HolidayDto },
  TContext
> => {
  const mutationKey = ["saveHoliday"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof saveHoliday>>,
    { data: HolidayDto }
  > = (props) => {
    const { data } = props ?? {};

    return saveHoliday(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SaveHolidayMutationResult = NonNullable<
  Awaited<ReturnType<typeof saveHoliday>>
>;
export type SaveHolidayMutationBody = HolidayDto;
export type SaveHolidayMutationError = AxiosError<HolidayResponseDto>;

/**
 * @summary Create a holiday
 */
export const useSaveHoliday = <
  TError = AxiosError<HolidayResponseDto>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof saveHoliday>>,
      TError,
      { data: HolidayDto },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof saveHoliday>>,
  TError,
  { data: HolidayDto },
  TContext
> => {
  const mutationOptions = getSaveHolidayMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Remove a holiday from the calendar
 * @summary Delete a holiday
 */
export const deleteHoliday = (
  params: DeleteHolidayParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<null>> => {
  return axios.default.delete(
    `https://leave.uibfs.or.ug/uib-api/leave/config/holidays`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getDeleteHolidayMutationOptions = <
  TError = AxiosError<null>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteHoliday>>,
    TError,
    { params: DeleteHolidayParams },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteHoliday>>,
  TError,
  { params: DeleteHolidayParams },
  TContext
> => {
  const mutationKey = ["deleteHoliday"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteHoliday>>,
    { params: DeleteHolidayParams }
  > = (props) => {
    const { params } = props ?? {};

    return deleteHoliday(params, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteHolidayMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteHoliday>>
>;

export type DeleteHolidayMutationError = AxiosError<null>;

/**
 * @summary Delete a holiday
 */
export const useDeleteHoliday = <TError = AxiosError<null>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteHoliday>>,
      TError,
      { params: DeleteHolidayParams },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteHoliday>>,
  TError,
  { params: DeleteHolidayParams },
  TContext
> => {
  const mutationOptions = getDeleteHolidayMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Manually trigger the year-end rollover process. Carries unused annual leave into the new year (up to the cap) and deducts borrowed days from new year entitlement.
 * @summary Trigger year-end rollover (Admin)
 */
export const triggerYearEndRollover = (
  params: TriggerYearEndRolloverParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ApiResponse>> => {
  return axios.default.post(
    `https://leave.uibfs.or.ug/uib-api/leave/balances/year-end-rollover`,
    undefined,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getTriggerYearEndRolloverMutationOptions = <
  TError = AxiosError<ApiResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof triggerYearEndRollover>>,
    TError,
    { params: TriggerYearEndRolloverParams },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof triggerYearEndRollover>>,
  TError,
  { params: TriggerYearEndRolloverParams },
  TContext
> => {
  const mutationKey = ["triggerYearEndRollover"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof triggerYearEndRollover>>,
    { params: TriggerYearEndRolloverParams }
  > = (props) => {
    const { params } = props ?? {};

    return triggerYearEndRollover(params, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TriggerYearEndRolloverMutationResult = NonNullable<
  Awaited<ReturnType<typeof triggerYearEndRollover>>
>;

export type TriggerYearEndRolloverMutationError = AxiosError<ApiResponse>;

/**
 * @summary Trigger year-end rollover (Admin)
 */
export const useTriggerYearEndRollover = <
  TError = AxiosError<ApiResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof triggerYearEndRollover>>,
      TError,
      { params: TriggerYearEndRolloverParams },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof triggerYearEndRollover>>,
  TError,
  { params: TriggerYearEndRolloverParams },
  TContext
> => {
  const mutationOptions = getTriggerYearEndRolloverMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Manually trigger forfeiture of expired carryover days
 * @summary Forfeit expired carryover (Admin)
 */
export const forfeitExpiredCarryover = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ApiResponse>> => {
  return axios.default.post(
    `https://leave.uibfs.or.ug/uib-api/leave/balances/forfeit-expired-carryover`,
    undefined,
    options,
  );
};

export const getForfeitExpiredCarryoverMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof forfeitExpiredCarryover>>,
    TError,
    void,
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof forfeitExpiredCarryover>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["forfeitExpiredCarryover"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof forfeitExpiredCarryover>>,
    void
  > = () => {
    return forfeitExpiredCarryover(axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ForfeitExpiredCarryoverMutationResult = NonNullable<
  Awaited<ReturnType<typeof forfeitExpiredCarryover>>
>;

export type ForfeitExpiredCarryoverMutationError = AxiosError<unknown>;

/**
 * @summary Forfeit expired carryover (Admin)
 */
export const useForfeitExpiredCarryover = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof forfeitExpiredCarryover>>,
      TError,
      void,
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof forfeitExpiredCarryover>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getForfeitExpiredCarryoverMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Update dates or reason for a draft/submitted leave request
 * @summary Update a leave request
 */
export const updateLeave = (
  id: number,
  leaveRequestUpdateDto: LeaveRequestUpdateDto,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ApiResponse>> => {
  return axios.default.patch(
    `https://leave.uibfs.or.ug/uib-api/leave/leave-requests/${id}`,
    leaveRequestUpdateDto,
    options,
  );
};

export const getUpdateLeaveMutationOptions = <
  TError = AxiosError<
    ApiResponse | ApiResponse | ApiResponse | ApiResponse | ApiResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateLeave>>,
    TError,
    { id: number; data: LeaveRequestUpdateDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateLeave>>,
  TError,
  { id: number; data: LeaveRequestUpdateDto },
  TContext
> => {
  const mutationKey = ["updateLeave"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateLeave>>,
    { id: number; data: LeaveRequestUpdateDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateLeave(id, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateLeaveMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateLeave>>
>;
export type UpdateLeaveMutationBody = LeaveRequestUpdateDto;
export type UpdateLeaveMutationError = AxiosError<
  ApiResponse | ApiResponse | ApiResponse | ApiResponse | ApiResponse
>;

/**
 * @summary Update a leave request
 */
export const useUpdateLeave = <
  TError = AxiosError<
    ApiResponse | ApiResponse | ApiResponse | ApiResponse | ApiResponse
  >,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateLeave>>,
      TError,
      { id: number; data: LeaveRequestUpdateDto },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateLeave>>,
  TError,
  { id: number; data: LeaveRequestUpdateDto },
  TContext
> => {
  const mutationOptions = getUpdateLeaveMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Returns high-level KPIs for the selected period.
 * @summary Leave dashboard summary
 */
export const summary = (
  params?: SummaryParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<LeaveSummaryReportResponse>> => {
  return axios.default.get(
    `https://leave.uibfs.or.ug/uib-api/leave/reports/summary`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getSummaryQueryKey = (params?: SummaryParams) => {
  return [
    `https://leave.uibfs.or.ug/uib-api/leave/reports/summary`,
    ...(params ? [params] : []),
  ] as const;
};

export const getSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof summary>>,
  TError = AxiosError<unknown>,
>(
  params?: SummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof summary>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSummaryQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof summary>>> = ({
    signal,
  }) => summary(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof summary>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type SummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof summary>>
>;
export type SummaryQueryError = AxiosError<unknown>;

export function useSummary<
  TData = Awaited<ReturnType<typeof summary>>,
  TError = AxiosError<unknown>,
>(
  params: undefined | SummaryParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof summary>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof summary>>,
          TError,
          Awaited<ReturnType<typeof summary>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useSummary<
  TData = Awaited<ReturnType<typeof summary>>,
  TError = AxiosError<unknown>,
>(
  params?: SummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof summary>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof summary>>,
          TError,
          Awaited<ReturnType<typeof summary>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useSummary<
  TData = Awaited<ReturnType<typeof summary>>,
  TError = AxiosError<unknown>,
>(
  params?: SummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof summary>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Leave dashboard summary
 */

export function useSummary<
  TData = Awaited<ReturnType<typeof summary>>,
  TError = AxiosError<unknown>,
>(
  params?: SummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof summary>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getSummaryQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Aggregates leave usage by leave type for the selected period.
 * @summary Leave type usage report
 */
export const leaveTypeUsage = (
  params?: LeaveTypeUsageParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<LeaveTypeUsageReportResponse>> => {
  return axios.default.get(
    `https://leave.uibfs.or.ug/uib-api/leave/reports/leave-type-usage`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getLeaveTypeUsageQueryKey = (params?: LeaveTypeUsageParams) => {
  return [
    `https://leave.uibfs.or.ug/uib-api/leave/reports/leave-type-usage`,
    ...(params ? [params] : []),
  ] as const;
};

export const getLeaveTypeUsageQueryOptions = <
  TData = Awaited<ReturnType<typeof leaveTypeUsage>>,
  TError = AxiosError<unknown>,
>(
  params?: LeaveTypeUsageParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof leaveTypeUsage>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getLeaveTypeUsageQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof leaveTypeUsage>>> = ({
    signal,
  }) => leaveTypeUsage(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof leaveTypeUsage>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type LeaveTypeUsageQueryResult = NonNullable<
  Awaited<ReturnType<typeof leaveTypeUsage>>
>;
export type LeaveTypeUsageQueryError = AxiosError<unknown>;

export function useLeaveTypeUsage<
  TData = Awaited<ReturnType<typeof leaveTypeUsage>>,
  TError = AxiosError<unknown>,
>(
  params: undefined | LeaveTypeUsageParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof leaveTypeUsage>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof leaveTypeUsage>>,
          TError,
          Awaited<ReturnType<typeof leaveTypeUsage>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useLeaveTypeUsage<
  TData = Awaited<ReturnType<typeof leaveTypeUsage>>,
  TError = AxiosError<unknown>,
>(
  params?: LeaveTypeUsageParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof leaveTypeUsage>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof leaveTypeUsage>>,
          TError,
          Awaited<ReturnType<typeof leaveTypeUsage>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useLeaveTypeUsage<
  TData = Awaited<ReturnType<typeof leaveTypeUsage>>,
  TError = AxiosError<unknown>,
>(
  params?: LeaveTypeUsageParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof leaveTypeUsage>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Leave type usage report
 */

export function useLeaveTypeUsage<
  TData = Awaited<ReturnType<typeof leaveTypeUsage>>,
  TError = AxiosError<unknown>,
>(
  params?: LeaveTypeUsageParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof leaveTypeUsage>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getLeaveTypeUsageQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Aggregates leave usage by grouped leave types for the selected period.
 * @summary Leave type group usage report
 */
export const leaveTypeGroups = (
  params?: LeaveTypeGroupsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<LeaveTypeGroupUsageReportResponse>> => {
  return axios.default.get(
    `https://leave.uibfs.or.ug/uib-api/leave/reports/leave-type-groups`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getLeaveTypeGroupsQueryKey = (params?: LeaveTypeGroupsParams) => {
  return [
    `https://leave.uibfs.or.ug/uib-api/leave/reports/leave-type-groups`,
    ...(params ? [params] : []),
  ] as const;
};

export const getLeaveTypeGroupsQueryOptions = <
  TData = Awaited<ReturnType<typeof leaveTypeGroups>>,
  TError = AxiosError<unknown>,
>(
  params?: LeaveTypeGroupsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof leaveTypeGroups>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getLeaveTypeGroupsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof leaveTypeGroups>>> = ({
    signal,
  }) => leaveTypeGroups(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof leaveTypeGroups>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type LeaveTypeGroupsQueryResult = NonNullable<
  Awaited<ReturnType<typeof leaveTypeGroups>>
>;
export type LeaveTypeGroupsQueryError = AxiosError<unknown>;

export function useLeaveTypeGroups<
  TData = Awaited<ReturnType<typeof leaveTypeGroups>>,
  TError = AxiosError<unknown>,
>(
  params: undefined | LeaveTypeGroupsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof leaveTypeGroups>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof leaveTypeGroups>>,
          TError,
          Awaited<ReturnType<typeof leaveTypeGroups>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useLeaveTypeGroups<
  TData = Awaited<ReturnType<typeof leaveTypeGroups>>,
  TError = AxiosError<unknown>,
>(
  params?: LeaveTypeGroupsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof leaveTypeGroups>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof leaveTypeGroups>>,
          TError,
          Awaited<ReturnType<typeof leaveTypeGroups>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useLeaveTypeGroups<
  TData = Awaited<ReturnType<typeof leaveTypeGroups>>,
  TError = AxiosError<unknown>,
>(
  params?: LeaveTypeGroupsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof leaveTypeGroups>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Leave type group usage report
 */

export function useLeaveTypeGroups<
  TData = Awaited<ReturnType<typeof leaveTypeGroups>>,
  TError = AxiosError<unknown>,
>(
  params?: LeaveTypeGroupsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof leaveTypeGroups>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getLeaveTypeGroupsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Shows directorate-level leave participation, usage, and request volume.
 * @summary Directorate leave performance
 */
export const directoratePerformance = (
  params?: DirectoratePerformanceParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<DirectoratePerformanceReportResponse>> => {
  return axios.default.get(
    `https://leave.uibfs.or.ug/uib-api/leave/reports/directorate-performance`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getDirectoratePerformanceQueryKey = (
  params?: DirectoratePerformanceParams,
) => {
  return [
    `https://leave.uibfs.or.ug/uib-api/leave/reports/directorate-performance`,
    ...(params ? [params] : []),
  ] as const;
};

export const getDirectoratePerformanceQueryOptions = <
  TData = Awaited<ReturnType<typeof directoratePerformance>>,
  TError = AxiosError<unknown>,
>(
  params?: DirectoratePerformanceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof directoratePerformance>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDirectoratePerformanceQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof directoratePerformance>>
  > = ({ signal }) =>
    directoratePerformance(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof directoratePerformance>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DirectoratePerformanceQueryResult = NonNullable<
  Awaited<ReturnType<typeof directoratePerformance>>
>;
export type DirectoratePerformanceQueryError = AxiosError<unknown>;

export function useDirectoratePerformance<
  TData = Awaited<ReturnType<typeof directoratePerformance>>,
  TError = AxiosError<unknown>,
>(
  params: undefined | DirectoratePerformanceParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof directoratePerformance>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof directoratePerformance>>,
          TError,
          Awaited<ReturnType<typeof directoratePerformance>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useDirectoratePerformance<
  TData = Awaited<ReturnType<typeof directoratePerformance>>,
  TError = AxiosError<unknown>,
>(
  params?: DirectoratePerformanceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof directoratePerformance>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof directoratePerformance>>,
          TError,
          Awaited<ReturnType<typeof directoratePerformance>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDirectoratePerformance<
  TData = Awaited<ReturnType<typeof directoratePerformance>>,
  TError = AxiosError<unknown>,
>(
  params?: DirectoratePerformanceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof directoratePerformance>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Directorate leave performance
 */

export function useDirectoratePerformance<
  TData = Awaited<ReturnType<typeof directoratePerformance>>,
  TError = AxiosError<unknown>,
>(
  params?: DirectoratePerformanceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof directoratePerformance>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDirectoratePerformanceQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Shows department-level leave participation, usage, and request volume.
 * @summary Department leave performance
 */
export const departmentPerformance = (
  params?: DepartmentPerformanceParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<DepartmentPerformanceReportResponse>> => {
  return axios.default.get(
    `https://leave.uibfs.or.ug/uib-api/leave/reports/department-performance`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getDepartmentPerformanceQueryKey = (
  params?: DepartmentPerformanceParams,
) => {
  return [
    `https://leave.uibfs.or.ug/uib-api/leave/reports/department-performance`,
    ...(params ? [params] : []),
  ] as const;
};

export const getDepartmentPerformanceQueryOptions = <
  TData = Awaited<ReturnType<typeof departmentPerformance>>,
  TError = AxiosError<unknown>,
>(
  params?: DepartmentPerformanceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof departmentPerformance>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDepartmentPerformanceQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof departmentPerformance>>
  > = ({ signal }) =>
    departmentPerformance(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof departmentPerformance>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DepartmentPerformanceQueryResult = NonNullable<
  Awaited<ReturnType<typeof departmentPerformance>>
>;
export type DepartmentPerformanceQueryError = AxiosError<unknown>;

export function useDepartmentPerformance<
  TData = Awaited<ReturnType<typeof departmentPerformance>>,
  TError = AxiosError<unknown>,
>(
  params: undefined | DepartmentPerformanceParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof departmentPerformance>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof departmentPerformance>>,
          TError,
          Awaited<ReturnType<typeof departmentPerformance>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useDepartmentPerformance<
  TData = Awaited<ReturnType<typeof departmentPerformance>>,
  TError = AxiosError<unknown>,
>(
  params?: DepartmentPerformanceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof departmentPerformance>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof departmentPerformance>>,
          TError,
          Awaited<ReturnType<typeof departmentPerformance>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDepartmentPerformance<
  TData = Awaited<ReturnType<typeof departmentPerformance>>,
  TError = AxiosError<unknown>,
>(
  params?: DepartmentPerformanceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof departmentPerformance>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Department leave performance
 */

export function useDepartmentPerformance<
  TData = Awaited<ReturnType<typeof departmentPerformance>>,
  TError = AxiosError<unknown>,
>(
  params?: DepartmentPerformanceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof departmentPerformance>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDepartmentPerformanceQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns summary KPIs, department performance, leave type usage, and grouped leave usage filtered by leave type.
 * @summary Combined leave dashboard report
 */
export const dashboard = (
  params?: DashboardParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<LeaveDashboardReportResponse>> => {
  return axios.default.get(
    `https://leave.uibfs.or.ug/uib-api/leave/reports/dashboard`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getDashboardQueryKey = (params?: DashboardParams) => {
  return [
    `https://leave.uibfs.or.ug/uib-api/leave/reports/dashboard`,
    ...(params ? [params] : []),
  ] as const;
};

export const getDashboardQueryOptions = <
  TData = Awaited<ReturnType<typeof dashboard>>,
  TError = AxiosError<unknown>,
>(
  params?: DashboardParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboard>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDashboardQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dashboard>>> = ({
    signal,
  }) => dashboard(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dashboard>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DashboardQueryResult = NonNullable<
  Awaited<ReturnType<typeof dashboard>>
>;
export type DashboardQueryError = AxiosError<unknown>;

export function useDashboard<
  TData = Awaited<ReturnType<typeof dashboard>>,
  TError = AxiosError<unknown>,
>(
  params: undefined | DashboardParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboard>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboard>>,
          TError,
          Awaited<ReturnType<typeof dashboard>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useDashboard<
  TData = Awaited<ReturnType<typeof dashboard>>,
  TError = AxiosError<unknown>,
>(
  params?: DashboardParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboard>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dashboard>>,
          TError,
          Awaited<ReturnType<typeof dashboard>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDashboard<
  TData = Awaited<ReturnType<typeof dashboard>>,
  TError = AxiosError<unknown>,
>(
  params?: DashboardParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboard>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Combined leave dashboard report
 */

export function useDashboard<
  TData = Awaited<ReturnType<typeof dashboard>>,
  TError = AxiosError<unknown>,
>(
  params?: DashboardParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dashboard>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDashboardQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get complete lifecycle tracking information for a leave application, including approval chain with completion status, approvers, and timestamps at each stage
 * @summary Track leave application lifecycle
 */
export const trackLeaveApplication = (
  id: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<LeaveTrackingDto>> => {
  return axios.default.get(
    `https://leave.uibfs.or.ug/uib-api/leave/leave-requests/${id}/tracking`,
    options,
  );
};

export const getTrackLeaveApplicationQueryKey = (id?: number) => {
  return [
    `https://leave.uibfs.or.ug/uib-api/leave/leave-requests/${id}/tracking`,
  ] as const;
};

export const getTrackLeaveApplicationQueryOptions = <
  TData = Awaited<ReturnType<typeof trackLeaveApplication>>,
  TError = AxiosError<LeaveTrackingDto | LeaveTrackingDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackLeaveApplication>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getTrackLeaveApplicationQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof trackLeaveApplication>>
  > = ({ signal }) => trackLeaveApplication(id, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof trackLeaveApplication>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type TrackLeaveApplicationQueryResult = NonNullable<
  Awaited<ReturnType<typeof trackLeaveApplication>>
>;
export type TrackLeaveApplicationQueryError = AxiosError<
  LeaveTrackingDto | LeaveTrackingDto
>;

export function useTrackLeaveApplication<
  TData = Awaited<ReturnType<typeof trackLeaveApplication>>,
  TError = AxiosError<LeaveTrackingDto | LeaveTrackingDto>,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackLeaveApplication>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof trackLeaveApplication>>,
          TError,
          Awaited<ReturnType<typeof trackLeaveApplication>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useTrackLeaveApplication<
  TData = Awaited<ReturnType<typeof trackLeaveApplication>>,
  TError = AxiosError<LeaveTrackingDto | LeaveTrackingDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackLeaveApplication>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof trackLeaveApplication>>,
          TError,
          Awaited<ReturnType<typeof trackLeaveApplication>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useTrackLeaveApplication<
  TData = Awaited<ReturnType<typeof trackLeaveApplication>>,
  TError = AxiosError<LeaveTrackingDto | LeaveTrackingDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackLeaveApplication>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Track leave application lifecycle
 */

export function useTrackLeaveApplication<
  TData = Awaited<ReturnType<typeof trackLeaveApplication>>,
  TError = AxiosError<LeaveTrackingDto | LeaveTrackingDto>,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof trackLeaveApplication>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getTrackLeaveApplicationQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Supervisor retrieves leave requests currently awaiting their approval
 * @summary Get leave requests pending my approval
 */
export const supervisorPendingRequests = (
  params: SupervisorPendingRequestsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<PageLeaveRequestDto>> => {
  return axios.default.get(
    `https://leave.uibfs.or.ug/uib-api/leave/leave-requests/supervisor/pending`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getSupervisorPendingRequestsQueryKey = (
  params?: SupervisorPendingRequestsParams,
) => {
  return [
    `https://leave.uibfs.or.ug/uib-api/leave/leave-requests/supervisor/pending`,
    ...(params ? [params] : []),
  ] as const;
};

export const getSupervisorPendingRequestsQueryOptions = <
  TData = Awaited<ReturnType<typeof supervisorPendingRequests>>,
  TError = AxiosError<PageLeaveRequestDto | PageLeaveRequestDto>,
>(
  params: SupervisorPendingRequestsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof supervisorPendingRequests>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSupervisorPendingRequestsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof supervisorPendingRequests>>
  > = ({ signal }) =>
    supervisorPendingRequests(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof supervisorPendingRequests>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type SupervisorPendingRequestsQueryResult = NonNullable<
  Awaited<ReturnType<typeof supervisorPendingRequests>>
>;
export type SupervisorPendingRequestsQueryError = AxiosError<
  PageLeaveRequestDto | PageLeaveRequestDto
>;

export function useSupervisorPendingRequests<
  TData = Awaited<ReturnType<typeof supervisorPendingRequests>>,
  TError = AxiosError<PageLeaveRequestDto | PageLeaveRequestDto>,
>(
  params: SupervisorPendingRequestsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof supervisorPendingRequests>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof supervisorPendingRequests>>,
          TError,
          Awaited<ReturnType<typeof supervisorPendingRequests>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useSupervisorPendingRequests<
  TData = Awaited<ReturnType<typeof supervisorPendingRequests>>,
  TError = AxiosError<PageLeaveRequestDto | PageLeaveRequestDto>,
>(
  params: SupervisorPendingRequestsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof supervisorPendingRequests>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof supervisorPendingRequests>>,
          TError,
          Awaited<ReturnType<typeof supervisorPendingRequests>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useSupervisorPendingRequests<
  TData = Awaited<ReturnType<typeof supervisorPendingRequests>>,
  TError = AxiosError<PageLeaveRequestDto | PageLeaveRequestDto>,
>(
  params: SupervisorPendingRequestsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof supervisorPendingRequests>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get leave requests pending my approval
 */

export function useSupervisorPendingRequests<
  TData = Awaited<ReturnType<typeof supervisorPendingRequests>>,
  TError = AxiosError<PageLeaveRequestDto | PageLeaveRequestDto>,
>(
  params: SupervisorPendingRequestsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof supervisorPendingRequests>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getSupervisorPendingRequestsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Supervisor retrieves leave requests previously approved or acknowledged
 * @summary Get leave requests approved by my office
 */
export const supervisorApprovedRequests = (
  params: SupervisorApprovedRequestsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<PageLeaveRequestDto>> => {
  return axios.default.get(
    `https://leave.uibfs.or.ug/uib-api/leave/leave-requests/supervisor/approved`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getSupervisorApprovedRequestsQueryKey = (
  params?: SupervisorApprovedRequestsParams,
) => {
  return [
    `https://leave.uibfs.or.ug/uib-api/leave/leave-requests/supervisor/approved`,
    ...(params ? [params] : []),
  ] as const;
};

export const getSupervisorApprovedRequestsQueryOptions = <
  TData = Awaited<ReturnType<typeof supervisorApprovedRequests>>,
  TError = AxiosError<PageLeaveRequestDto | PageLeaveRequestDto>,
>(
  params: SupervisorApprovedRequestsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof supervisorApprovedRequests>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSupervisorApprovedRequestsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof supervisorApprovedRequests>>
  > = ({ signal }) =>
    supervisorApprovedRequests(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof supervisorApprovedRequests>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type SupervisorApprovedRequestsQueryResult = NonNullable<
  Awaited<ReturnType<typeof supervisorApprovedRequests>>
>;
export type SupervisorApprovedRequestsQueryError = AxiosError<
  PageLeaveRequestDto | PageLeaveRequestDto
>;

export function useSupervisorApprovedRequests<
  TData = Awaited<ReturnType<typeof supervisorApprovedRequests>>,
  TError = AxiosError<PageLeaveRequestDto | PageLeaveRequestDto>,
>(
  params: SupervisorApprovedRequestsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof supervisorApprovedRequests>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof supervisorApprovedRequests>>,
          TError,
          Awaited<ReturnType<typeof supervisorApprovedRequests>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useSupervisorApprovedRequests<
  TData = Awaited<ReturnType<typeof supervisorApprovedRequests>>,
  TError = AxiosError<PageLeaveRequestDto | PageLeaveRequestDto>,
>(
  params: SupervisorApprovedRequestsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof supervisorApprovedRequests>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof supervisorApprovedRequests>>,
          TError,
          Awaited<ReturnType<typeof supervisorApprovedRequests>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useSupervisorApprovedRequests<
  TData = Awaited<ReturnType<typeof supervisorApprovedRequests>>,
  TError = AxiosError<PageLeaveRequestDto | PageLeaveRequestDto>,
>(
  params: SupervisorApprovedRequestsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof supervisorApprovedRequests>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get leave requests approved by my office
 */

export function useSupervisorApprovedRequests<
  TData = Awaited<ReturnType<typeof supervisorApprovedRequests>>,
  TError = AxiosError<PageLeaveRequestDto | PageLeaveRequestDto>,
>(
  params: SupervisorApprovedRequestsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof supervisorApprovedRequests>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getSupervisorApprovedRequestsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Retrieve leave requests for current user's department, organisation, or all (admin only)
 * @summary Get leave requests by scope
 */
export const leaveRequestsByScope = (
  params: LeaveRequestsByScopeParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<PageLeaveRequestAdminListItemDto>> => {
  return axios.default.get(
    `https://leave.uibfs.or.ug/uib-api/leave/leave-requests/scope`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getLeaveRequestsByScopeQueryKey = (
  params?: LeaveRequestsByScopeParams,
) => {
  return [
    `https://leave.uibfs.or.ug/uib-api/leave/leave-requests/scope`,
    ...(params ? [params] : []),
  ] as const;
};

export const getLeaveRequestsByScopeQueryOptions = <
  TData = Awaited<ReturnType<typeof leaveRequestsByScope>>,
  TError = AxiosError<
    | PageLeaveRequestAdminListItemDto
    | PageLeaveRequestAdminListItemDto
    | PageLeaveRequestAdminListItemDto
  >,
>(
  params: LeaveRequestsByScopeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof leaveRequestsByScope>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getLeaveRequestsByScopeQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof leaveRequestsByScope>>
  > = ({ signal }) => leaveRequestsByScope(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof leaveRequestsByScope>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type LeaveRequestsByScopeQueryResult = NonNullable<
  Awaited<ReturnType<typeof leaveRequestsByScope>>
>;
export type LeaveRequestsByScopeQueryError = AxiosError<
  | PageLeaveRequestAdminListItemDto
  | PageLeaveRequestAdminListItemDto
  | PageLeaveRequestAdminListItemDto
>;

export function useLeaveRequestsByScope<
  TData = Awaited<ReturnType<typeof leaveRequestsByScope>>,
  TError = AxiosError<
    | PageLeaveRequestAdminListItemDto
    | PageLeaveRequestAdminListItemDto
    | PageLeaveRequestAdminListItemDto
  >,
>(
  params: LeaveRequestsByScopeParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof leaveRequestsByScope>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof leaveRequestsByScope>>,
          TError,
          Awaited<ReturnType<typeof leaveRequestsByScope>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useLeaveRequestsByScope<
  TData = Awaited<ReturnType<typeof leaveRequestsByScope>>,
  TError = AxiosError<
    | PageLeaveRequestAdminListItemDto
    | PageLeaveRequestAdminListItemDto
    | PageLeaveRequestAdminListItemDto
  >,
>(
  params: LeaveRequestsByScopeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof leaveRequestsByScope>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof leaveRequestsByScope>>,
          TError,
          Awaited<ReturnType<typeof leaveRequestsByScope>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useLeaveRequestsByScope<
  TData = Awaited<ReturnType<typeof leaveRequestsByScope>>,
  TError = AxiosError<
    | PageLeaveRequestAdminListItemDto
    | PageLeaveRequestAdminListItemDto
    | PageLeaveRequestAdminListItemDto
  >,
>(
  params: LeaveRequestsByScopeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof leaveRequestsByScope>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get leave requests by scope
 */

export function useLeaveRequestsByScope<
  TData = Awaited<ReturnType<typeof leaveRequestsByScope>>,
  TError = AxiosError<
    | PageLeaveRequestAdminListItemDto
    | PageLeaveRequestAdminListItemDto
    | PageLeaveRequestAdminListItemDto
  >,
>(
  params: LeaveRequestsByScopeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof leaveRequestsByScope>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getLeaveRequestsByScopeQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Retrieve leave types matching the current user's entitlements
 * @summary List eligible leave types
 */
export const myEligibleLeaveTypes = (
  params: MyEligibleLeaveTypesParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<PageLeaveTypeDto>> => {
  return axios.default.get(
    `https://leave.uibfs.or.ug/uib-api/leave/leave-requests/leave-types`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getMyEligibleLeaveTypesQueryKey = (
  params?: MyEligibleLeaveTypesParams,
) => {
  return [
    `https://leave.uibfs.or.ug/uib-api/leave/leave-requests/leave-types`,
    ...(params ? [params] : []),
  ] as const;
};

export const getMyEligibleLeaveTypesQueryOptions = <
  TData = Awaited<ReturnType<typeof myEligibleLeaveTypes>>,
  TError = AxiosError<unknown>,
>(
  params: MyEligibleLeaveTypesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof myEligibleLeaveTypes>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getMyEligibleLeaveTypesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof myEligibleLeaveTypes>>
  > = ({ signal }) => myEligibleLeaveTypes(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof myEligibleLeaveTypes>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type MyEligibleLeaveTypesQueryResult = NonNullable<
  Awaited<ReturnType<typeof myEligibleLeaveTypes>>
>;
export type MyEligibleLeaveTypesQueryError = AxiosError<unknown>;

export function useMyEligibleLeaveTypes<
  TData = Awaited<ReturnType<typeof myEligibleLeaveTypes>>,
  TError = AxiosError<unknown>,
>(
  params: MyEligibleLeaveTypesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof myEligibleLeaveTypes>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof myEligibleLeaveTypes>>,
          TError,
          Awaited<ReturnType<typeof myEligibleLeaveTypes>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useMyEligibleLeaveTypes<
  TData = Awaited<ReturnType<typeof myEligibleLeaveTypes>>,
  TError = AxiosError<unknown>,
>(
  params: MyEligibleLeaveTypesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof myEligibleLeaveTypes>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof myEligibleLeaveTypes>>,
          TError,
          Awaited<ReturnType<typeof myEligibleLeaveTypes>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useMyEligibleLeaveTypes<
  TData = Awaited<ReturnType<typeof myEligibleLeaveTypes>>,
  TError = AxiosError<unknown>,
>(
  params: MyEligibleLeaveTypesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof myEligibleLeaveTypes>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List eligible leave types
 */

export function useMyEligibleLeaveTypes<
  TData = Awaited<ReturnType<typeof myEligibleLeaveTypes>>,
  TError = AxiosError<unknown>,
>(
  params: MyEligibleLeaveTypesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof myEligibleLeaveTypes>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getMyEligibleLeaveTypesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Retrieve leave types matching the specified user's entitlements
 * @summary List eligible leave types for a user
 */
export const eligibleLeaveTypesForUser = (
  userId: number,
  params: EligibleLeaveTypesForUserParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<PageLeaveTypeDto>> => {
  return axios.default.get(
    `https://leave.uibfs.or.ug/uib-api/leave/leave-requests/leave-types/user/${userId}`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getEligibleLeaveTypesForUserQueryKey = (
  userId?: number,
  params?: EligibleLeaveTypesForUserParams,
) => {
  return [
    `https://leave.uibfs.or.ug/uib-api/leave/leave-requests/leave-types/user/${userId}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getEligibleLeaveTypesForUserQueryOptions = <
  TData = Awaited<ReturnType<typeof eligibleLeaveTypesForUser>>,
  TError = AxiosError<PageLeaveTypeDto | PageLeaveTypeDto>,
>(
  userId: number,
  params: EligibleLeaveTypesForUserParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof eligibleLeaveTypesForUser>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getEligibleLeaveTypesForUserQueryKey(userId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof eligibleLeaveTypesForUser>>
  > = ({ signal }) =>
    eligibleLeaveTypesForUser(userId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!userId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof eligibleLeaveTypesForUser>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type EligibleLeaveTypesForUserQueryResult = NonNullable<
  Awaited<ReturnType<typeof eligibleLeaveTypesForUser>>
>;
export type EligibleLeaveTypesForUserQueryError = AxiosError<
  PageLeaveTypeDto | PageLeaveTypeDto
>;

export function useEligibleLeaveTypesForUser<
  TData = Awaited<ReturnType<typeof eligibleLeaveTypesForUser>>,
  TError = AxiosError<PageLeaveTypeDto | PageLeaveTypeDto>,
>(
  userId: number,
  params: EligibleLeaveTypesForUserParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof eligibleLeaveTypesForUser>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof eligibleLeaveTypesForUser>>,
          TError,
          Awaited<ReturnType<typeof eligibleLeaveTypesForUser>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useEligibleLeaveTypesForUser<
  TData = Awaited<ReturnType<typeof eligibleLeaveTypesForUser>>,
  TError = AxiosError<PageLeaveTypeDto | PageLeaveTypeDto>,
>(
  userId: number,
  params: EligibleLeaveTypesForUserParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof eligibleLeaveTypesForUser>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof eligibleLeaveTypesForUser>>,
          TError,
          Awaited<ReturnType<typeof eligibleLeaveTypesForUser>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useEligibleLeaveTypesForUser<
  TData = Awaited<ReturnType<typeof eligibleLeaveTypesForUser>>,
  TError = AxiosError<PageLeaveTypeDto | PageLeaveTypeDto>,
>(
  userId: number,
  params: EligibleLeaveTypesForUserParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof eligibleLeaveTypesForUser>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List eligible leave types for a user
 */

export function useEligibleLeaveTypesForUser<
  TData = Awaited<ReturnType<typeof eligibleLeaveTypesForUser>>,
  TError = AxiosError<PageLeaveTypeDto | PageLeaveTypeDto>,
>(
  userId: number,
  params: EligibleLeaveTypesForUserParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof eligibleLeaveTypesForUser>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getEligibleLeaveTypesForUserQueryOptions(
    userId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Retrieve paginated list of all leave requests with optional filters
 * @summary Get all leave requests
 */
export const allLeaveRequests = (
  params: AllLeaveRequestsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<PageLeaveRequestAdminListItemDto>> => {
  return axios.default.get(
    `https://leave.uibfs.or.ug/uib-api/leave/leave-requests/all`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getAllLeaveRequestsQueryKey = (
  params?: AllLeaveRequestsParams,
) => {
  return [
    `https://leave.uibfs.or.ug/uib-api/leave/leave-requests/all`,
    ...(params ? [params] : []),
  ] as const;
};

export const getAllLeaveRequestsQueryOptions = <
  TData = Awaited<ReturnType<typeof allLeaveRequests>>,
  TError = AxiosError<
    PageLeaveRequestAdminListItemDto | PageLeaveRequestAdminListItemDto
  >,
>(
  params: AllLeaveRequestsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof allLeaveRequests>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAllLeaveRequestsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof allLeaveRequests>>
  > = ({ signal }) => allLeaveRequests(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof allLeaveRequests>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AllLeaveRequestsQueryResult = NonNullable<
  Awaited<ReturnType<typeof allLeaveRequests>>
>;
export type AllLeaveRequestsQueryError = AxiosError<
  PageLeaveRequestAdminListItemDto | PageLeaveRequestAdminListItemDto
>;

export function useAllLeaveRequests<
  TData = Awaited<ReturnType<typeof allLeaveRequests>>,
  TError = AxiosError<
    PageLeaveRequestAdminListItemDto | PageLeaveRequestAdminListItemDto
  >,
>(
  params: AllLeaveRequestsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof allLeaveRequests>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof allLeaveRequests>>,
          TError,
          Awaited<ReturnType<typeof allLeaveRequests>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useAllLeaveRequests<
  TData = Awaited<ReturnType<typeof allLeaveRequests>>,
  TError = AxiosError<
    PageLeaveRequestAdminListItemDto | PageLeaveRequestAdminListItemDto
  >,
>(
  params: AllLeaveRequestsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof allLeaveRequests>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof allLeaveRequests>>,
          TError,
          Awaited<ReturnType<typeof allLeaveRequests>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAllLeaveRequests<
  TData = Awaited<ReturnType<typeof allLeaveRequests>>,
  TError = AxiosError<
    PageLeaveRequestAdminListItemDto | PageLeaveRequestAdminListItemDto
  >,
>(
  params: AllLeaveRequestsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof allLeaveRequests>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get all leave requests
 */

export function useAllLeaveRequests<
  TData = Awaited<ReturnType<typeof allLeaveRequests>>,
  TError = AxiosError<
    PageLeaveRequestAdminListItemDto | PageLeaveRequestAdminListItemDto
  >,
>(
  params: AllLeaveRequestsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof allLeaveRequests>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAllLeaveRequestsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Organisation admins can view every delegation assignment
 * @summary List all delegations
 */
export const allDelegations = (
  params: AllDelegationsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<PageDelegationAssignmentDto>> => {
  return axios.default.get(
    `https://leave.uibfs.or.ug/uib-api/leave/delegations/all`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getAllDelegationsQueryKey = (params?: AllDelegationsParams) => {
  return [
    `https://leave.uibfs.or.ug/uib-api/leave/delegations/all`,
    ...(params ? [params] : []),
  ] as const;
};

export const getAllDelegationsQueryOptions = <
  TData = Awaited<ReturnType<typeof allDelegations>>,
  TError = AxiosError<
    PageDelegationAssignmentDto | PageDelegationAssignmentDto
  >,
>(
  params: AllDelegationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof allDelegations>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAllDelegationsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof allDelegations>>> = ({
    signal,
  }) => allDelegations(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof allDelegations>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AllDelegationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof allDelegations>>
>;
export type AllDelegationsQueryError = AxiosError<
  PageDelegationAssignmentDto | PageDelegationAssignmentDto
>;

export function useAllDelegations<
  TData = Awaited<ReturnType<typeof allDelegations>>,
  TError = AxiosError<
    PageDelegationAssignmentDto | PageDelegationAssignmentDto
  >,
>(
  params: AllDelegationsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof allDelegations>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof allDelegations>>,
          TError,
          Awaited<ReturnType<typeof allDelegations>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useAllDelegations<
  TData = Awaited<ReturnType<typeof allDelegations>>,
  TError = AxiosError<
    PageDelegationAssignmentDto | PageDelegationAssignmentDto
  >,
>(
  params: AllDelegationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof allDelegations>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof allDelegations>>,
          TError,
          Awaited<ReturnType<typeof allDelegations>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAllDelegations<
  TData = Awaited<ReturnType<typeof allDelegations>>,
  TError = AxiosError<
    PageDelegationAssignmentDto | PageDelegationAssignmentDto
  >,
>(
  params: AllDelegationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof allDelegations>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List all delegations
 */

export function useAllDelegations<
  TData = Awaited<ReturnType<typeof allDelegations>>,
  TError = AxiosError<
    PageDelegationAssignmentDto | PageDelegationAssignmentDto
  >,
>(
  params: AllDelegationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof allDelegations>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAllDelegationsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Retrieve detailed leave balances for a specific user
 * @summary Get leave balances for a user
 */
export const userBalances = (
  userId: number,
  params?: UserBalancesParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<LeaveBalanceDto[]>> => {
  return axios.default.get(
    `https://leave.uibfs.or.ug/uib-api/leave/balances/user/${userId}`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getUserBalancesQueryKey = (
  userId?: number,
  params?: UserBalancesParams,
) => {
  return [
    `https://leave.uibfs.or.ug/uib-api/leave/balances/user/${userId}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getUserBalancesQueryOptions = <
  TData = Awaited<ReturnType<typeof userBalances>>,
  TError = AxiosError<unknown>,
>(
  userId: number,
  params?: UserBalancesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof userBalances>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getUserBalancesQueryKey(userId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof userBalances>>> = ({
    signal,
  }) => userBalances(userId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!userId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof userBalances>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type UserBalancesQueryResult = NonNullable<
  Awaited<ReturnType<typeof userBalances>>
>;
export type UserBalancesQueryError = AxiosError<unknown>;

export function useUserBalances<
  TData = Awaited<ReturnType<typeof userBalances>>,
  TError = AxiosError<unknown>,
>(
  userId: number,
  params: undefined | UserBalancesParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof userBalances>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userBalances>>,
          TError,
          Awaited<ReturnType<typeof userBalances>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useUserBalances<
  TData = Awaited<ReturnType<typeof userBalances>>,
  TError = AxiosError<unknown>,
>(
  userId: number,
  params?: UserBalancesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof userBalances>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userBalances>>,
          TError,
          Awaited<ReturnType<typeof userBalances>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useUserBalances<
  TData = Awaited<ReturnType<typeof userBalances>>,
  TError = AxiosError<unknown>,
>(
  userId: number,
  params?: UserBalancesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof userBalances>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get leave balances for a user
 */

export function useUserBalances<
  TData = Awaited<ReturnType<typeof userBalances>>,
  TError = AxiosError<unknown>,
>(
  userId: number,
  params?: UserBalancesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof userBalances>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getUserBalancesQueryOptions(userId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Retrieve detailed balance breakdown for a specific user and leave type
 * @summary Get balance for specific user and leave type
 */
export const userLeaveTypeBalance = (
  userId: number,
  leaveTypeId: number,
  params?: UserLeaveTypeBalanceParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<LeaveBalanceDto>> => {
  return axios.default.get(
    `https://leave.uibfs.or.ug/uib-api/leave/balances/user/${userId}/leave-type/${leaveTypeId}`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getUserLeaveTypeBalanceQueryKey = (
  userId?: number,
  leaveTypeId?: number,
  params?: UserLeaveTypeBalanceParams,
) => {
  return [
    `https://leave.uibfs.or.ug/uib-api/leave/balances/user/${userId}/leave-type/${leaveTypeId}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getUserLeaveTypeBalanceQueryOptions = <
  TData = Awaited<ReturnType<typeof userLeaveTypeBalance>>,
  TError = AxiosError<unknown>,
>(
  userId: number,
  leaveTypeId: number,
  params?: UserLeaveTypeBalanceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof userLeaveTypeBalance>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getUserLeaveTypeBalanceQueryKey(userId, leaveTypeId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof userLeaveTypeBalance>>
  > = ({ signal }) =>
    userLeaveTypeBalance(userId, leaveTypeId, params, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(userId && leaveTypeId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof userLeaveTypeBalance>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type UserLeaveTypeBalanceQueryResult = NonNullable<
  Awaited<ReturnType<typeof userLeaveTypeBalance>>
>;
export type UserLeaveTypeBalanceQueryError = AxiosError<unknown>;

export function useUserLeaveTypeBalance<
  TData = Awaited<ReturnType<typeof userLeaveTypeBalance>>,
  TError = AxiosError<unknown>,
>(
  userId: number,
  leaveTypeId: number,
  params: undefined | UserLeaveTypeBalanceParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof userLeaveTypeBalance>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userLeaveTypeBalance>>,
          TError,
          Awaited<ReturnType<typeof userLeaveTypeBalance>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useUserLeaveTypeBalance<
  TData = Awaited<ReturnType<typeof userLeaveTypeBalance>>,
  TError = AxiosError<unknown>,
>(
  userId: number,
  leaveTypeId: number,
  params?: UserLeaveTypeBalanceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof userLeaveTypeBalance>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userLeaveTypeBalance>>,
          TError,
          Awaited<ReturnType<typeof userLeaveTypeBalance>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useUserLeaveTypeBalance<
  TData = Awaited<ReturnType<typeof userLeaveTypeBalance>>,
  TError = AxiosError<unknown>,
>(
  userId: number,
  leaveTypeId: number,
  params?: UserLeaveTypeBalanceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof userLeaveTypeBalance>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get balance for specific user and leave type
 */

export function useUserLeaveTypeBalance<
  TData = Awaited<ReturnType<typeof userLeaveTypeBalance>>,
  TError = AxiosError<unknown>,
>(
  userId: number,
  leaveTypeId: number,
  params?: UserLeaveTypeBalanceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof userLeaveTypeBalance>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getUserLeaveTypeBalanceQueryOptions(
    userId,
    leaveTypeId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Retrieve leave balances for an organisation and year. If organisationId is omitted, the current user's organisation is used. If year is omitted, the previous year is used.
 * @summary Get leave balances for an organisation
 */
export const organisationBalances = (
  params?: OrganisationBalancesParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<LeaveBalanceDto[]>> => {
  return axios.default.get(
    `https://leave.uibfs.or.ug/uib-api/leave/balances/organisation`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getOrganisationBalancesQueryKey = (
  params?: OrganisationBalancesParams,
) => {
  return [
    `https://leave.uibfs.or.ug/uib-api/leave/balances/organisation`,
    ...(params ? [params] : []),
  ] as const;
};

export const getOrganisationBalancesQueryOptions = <
  TData = Awaited<ReturnType<typeof organisationBalances>>,
  TError = AxiosError<unknown>,
>(
  params?: OrganisationBalancesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof organisationBalances>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getOrganisationBalancesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof organisationBalances>>
  > = ({ signal }) => organisationBalances(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof organisationBalances>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type OrganisationBalancesQueryResult = NonNullable<
  Awaited<ReturnType<typeof organisationBalances>>
>;
export type OrganisationBalancesQueryError = AxiosError<unknown>;

export function useOrganisationBalances<
  TData = Awaited<ReturnType<typeof organisationBalances>>,
  TError = AxiosError<unknown>,
>(
  params: undefined | OrganisationBalancesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof organisationBalances>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof organisationBalances>>,
          TError,
          Awaited<ReturnType<typeof organisationBalances>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useOrganisationBalances<
  TData = Awaited<ReturnType<typeof organisationBalances>>,
  TError = AxiosError<unknown>,
>(
  params?: OrganisationBalancesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof organisationBalances>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof organisationBalances>>,
          TError,
          Awaited<ReturnType<typeof organisationBalances>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useOrganisationBalances<
  TData = Awaited<ReturnType<typeof organisationBalances>>,
  TError = AxiosError<unknown>,
>(
  params?: OrganisationBalancesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof organisationBalances>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get leave balances for an organisation
 */

export function useOrganisationBalances<
  TData = Awaited<ReturnType<typeof organisationBalances>>,
  TError = AxiosError<unknown>,
>(
  params?: OrganisationBalancesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof organisationBalances>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getOrganisationBalancesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Current user's leave balances for the year, showing entitlement, carryover bucket (with expiry), and borrowing status. The same data is also embedded in GET /leave/leave-types.
 * @summary Get my leave balances
 */
export const myBalances = (
  params?: MyBalancesParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<LeaveBalanceDto[]>> => {
  return axios.default.get(
    `https://leave.uibfs.or.ug/uib-api/leave/balances/my`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getMyBalancesQueryKey = (params?: MyBalancesParams) => {
  return [
    `https://leave.uibfs.or.ug/uib-api/leave/balances/my`,
    ...(params ? [params] : []),
  ] as const;
};

export const getMyBalancesQueryOptions = <
  TData = Awaited<ReturnType<typeof myBalances>>,
  TError = AxiosError<unknown>,
>(
  params?: MyBalancesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof myBalances>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getMyBalancesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof myBalances>>> = ({
    signal,
  }) => myBalances(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof myBalances>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type MyBalancesQueryResult = NonNullable<
  Awaited<ReturnType<typeof myBalances>>
>;
export type MyBalancesQueryError = AxiosError<unknown>;

export function useMyBalances<
  TData = Awaited<ReturnType<typeof myBalances>>,
  TError = AxiosError<unknown>,
>(
  params: undefined | MyBalancesParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof myBalances>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof myBalances>>,
          TError,
          Awaited<ReturnType<typeof myBalances>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useMyBalances<
  TData = Awaited<ReturnType<typeof myBalances>>,
  TError = AxiosError<unknown>,
>(
  params?: MyBalancesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof myBalances>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof myBalances>>,
          TError,
          Awaited<ReturnType<typeof myBalances>>
        >,
        "initialData"
      >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useMyBalances<
  TData = Awaited<ReturnType<typeof myBalances>>,
  TError = AxiosError<unknown>,
>(
  params?: MyBalancesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof myBalances>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get my leave balances
 */

export function useMyBalances<
  TData = Awaited<ReturnType<typeof myBalances>>,
  TError = AxiosError<unknown>,
>(
  params?: MyBalancesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof myBalances>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getMyBalancesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Deactivate an existing delegation assignment
 * @summary Deactivate a delegation
 */
export const deactivate = (
  id: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<null>> => {
  return axios.default.delete(
    `https://leave.uibfs.or.ug/uib-api/leave/delegations/${id}`,
    options,
  );
};

export const getDeactivateMutationOptions = <
  TError = AxiosError<null>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deactivate>>,
    TError,
    { id: number },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deactivate>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deactivate"];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deactivate>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deactivate(id, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeactivateMutationResult = NonNullable<
  Awaited<ReturnType<typeof deactivate>>
>;

export type DeactivateMutationError = AxiosError<null>;

/**
 * @summary Deactivate a delegation
 */
export const useDeactivate = <TError = AxiosError<null>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deactivate>>,
      TError,
      { id: number },
      TContext
    >;
    axios?: AxiosRequestConfig;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deactivate>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeactivateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
